import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { UserAccountRole } from '@shared/user/enums';
import { CanActivateRoute } from '../../guards';
import { BillingComponent } from '../billing/billing.component';
import { PricePlansResolver } from '../resolvers';

const locationRoutes: Routes = [
  {
    path: 'users',
    loadChildren: () => import(/* webpackChunkName: "manager-settings-location-users" */ './users/users.module')
      .then(module => module.LocationUsersModule),
  },
  {
    path: 'info',
    loadChildren: () => import(/* webpackChunkName: "manager-settings-location-info" */ './location-info/location-info.module')
      .then(module => module.LocationInfoModule),
  },
  {
    path: 'billing',
    component: BillingComponent,
    canActivate: [CanActivateRoute],
    resolve: { pricePlans: PricePlansResolver },
    data: {
      scopes: ['manager:read'],
      availableFor: [UserAccountRole.user, UserAccountRole.admin],
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(locationRoutes)],
  exports: [RouterModule],
})
export class LocationRoutingModule {}
